import styled, { css } from 'styled-components';
import { Icon } from 'src/components';

const ArrowIcon = ({ ...props }) => <Icon {...props} name="arrowRight" />;
export const ButtonIcon = styled(ArrowIcon)(
  ({ theme }) => css`
    display: inline-block;
    height: ${theme.sz.s6};
    width: ${theme.sz.s6};
    margin-left: ${theme.sz.s2};

    svg {
      height: 100%;
      width: 100%;
      padding: calc(100% * 5 / 24) calc(100% * 3 / 24);
    }
  `,
);

export const SublistButton = styled.button(
  ({ theme }) => css`
    background: none;
    padding: ${theme.sz.s0};
    border: none;
    cursor: pointer;
    min-height: ${theme.sz.s8};
    transition: transform 0.5s ease;
    ${theme.typography.heading.desktop.xxxs};

    &:hover {
      transform: translateY(-${theme.sz.s05});
    }
  `,
);

export const SublistButtonWrapper = styled.div(
  ({ theme }) => css`
    min-height: ${theme.sz.s8};
  `,
);
